import { makeQuery } from 'shared/utilities';
import { IReservationPlaceModel, UserModel } from 'shared/models';

type RequestType = {
    name: string;
    description?: string;
    reservationPlaceId: number;
    startAt: string;
    endAt: string;
    users?: UserModel[];
};

type ResponseType = {
    items: IReservationPlaceModel[];
};

export const reservationsCreateQuery = async function (data: RequestType) {
    return await makeQuery<ResponseType>('/reservations/create', { json: data });
}
